import { USER } from 'shared/constants/actionTypes';
import { phoneNormalize } from 'shared/modules';

const initialState = {
  token: '',
  user: {},
  error: {},
  showSaveSearchBtn: false,
  savedSearches: null,
  balance: {
    isFetching: false,
    amount: null,
  },
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case USER.SET_SESSION:
      return {
        ...state,
        token: action.payload,
      };

    case USER.SET_USER: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    }

    case USER.SET_PHONE: {
      const thatPhones = state.user.phones.filter(phone => phone.number !== action.payload.number);
      const phones = [...thatPhones, action.payload].map(dat => ({
        ...dat,
        number: phoneNormalize(dat.number),
      }));
      return {
        ...state,
        user: {
          ...state.user,
          phones,
        },
      };
    }

    case USER.ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case USER.REMOVE_PHONE: {
      return {
        ...state,
        user: {
          ...state.user,
          phones: state.user.phones.filter(phone => {
            if (phone.number === action.payload.number) {
              return false;
            }
            return phone.id !== action.payload;
          }),
        },
      };
    }

    case USER.SET_BALANCE:
      return {
        ...state,
        balance: {
          ...state.balance,
          amount: action.payload,
        },
      };

    case USER.SET_BALANCE_IS_FETCHING:
      return {
        ...state,
        balance: {
          ...state.balance,
          isFetching: !!action.payload,
        },
      };

    case USER.LOGOUT: {
      return initialState;
    }
    case USER.REGISTRATION: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case USER.BEFORE_REGISTRATION: {
      return {
        ...state,
        beforeRegistration: action.payload
          ? { ...state.beforeRegistration, ...action.payload }
          : {},
      };
    }

    case USER.SET_SAVED_SEARCHES:
      return {
        ...state,
        savedSearches: action.payload,
      };

    case USER.SET_SHOW_SAVE_SEARCH_BTN:
      return {
        ...state,
        showSaveSearchBtn: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/shared/reducers/user.js